<template>
  <div>
    <div v-if="$slots.banner" class="z-49 sm:top-(--headerHeight)">
      <slot name="banner" />
    </div>
    <slot />
  </div>
</template>
